import { useEffect, useMemo, useCallback } from 'react';
import { BroadcastChannel } from 'broadcast-channel';
import { useRouter } from 'next/router';

// Track attendee login changes across hub tabs and windows and reload if any changes.
const useReloadOnAttendeeChange = (attendeeId = '', eventId = '') => {
  const router = useRouter();

  const channel = useMemo(() => {
    if (typeof window !== 'undefined') {
      return new BroadcastChannel('attendee');
    }
  }, []);

  const onMessage = useCallback(
    ({ aId, eId }) => {
      // Reload if the logged in attendeeId has changed but the eventId has stayed the same.
      if (aId !== attendeeId && eId === eventId) {
        router.reload();
      }
    },
    [attendeeId, eventId, router]
  );

  useEffect(() => {
    channel.addEventListener('message', onMessage);
    return () => {
      channel.removeEventListener('message', onMessage);
    };
  }, [channel, onMessage]);
};

export default useReloadOnAttendeeChange;
